module.exports = __webpack_public_path__ + "img/red-hat.13f33c02.png";